export function useClipboardCopy(resetDelayMs = 1800) {
  const copiedReferenceId = ref<string | null>(null)

  async function copyReference(referenceId: string, text: string | null) {
    if (!text || !import.meta.client || !navigator.clipboard) {
      return
    }

    await navigator.clipboard.writeText(text)
    copiedReferenceId.value = referenceId

    window.setTimeout(() => {
      if (copiedReferenceId.value === referenceId) {
        copiedReferenceId.value = null
      }
    }, resetDelayMs)
  }

  return {
    copiedReferenceId,
    copyReference,
  }
}
